/**
 * Utility class for generating random filenames from URLs
 */
export class FilenameGeneratorUtil {

  static generateRandomFilename(url: string): string {
    if (!url) {
      return this.createFilename('file', '.bin');
    }

    const lowerUrl = url.toLowerCase();
    const extension = this.getFileExtension(lowerUrl);
    const prefix = this.getFilePrefix(extension);

    return this.createFilename(prefix, extension);
  }

  private static getFileExtension(lowerUrl: string): string {
    // Video formats
    if (lowerUrl.includes('.mp4') || lowerUrl.includes('video')) {
      return '.mp4';
    }
    if (lowerUrl.includes('.mov')) {
      return '.mov';
    }
    if (lowerUrl.includes('.webm')) {
      return '.webm';
    }

    // Audio formats
    if (lowerUrl.includes('.mp3') || lowerUrl.includes('audio')) {
      return '.mp3';
    }
    if (lowerUrl.includes('.wav')) {
      return '.wav';
    }
    if (lowerUrl.includes('.ogg')) {
      return '.ogg';
    }

    // Image formats
    if (lowerUrl.includes('.png')) {
      return '.png';
    }
    if (lowerUrl.includes('.webp')) {
      return '.webp';
    }
    if (lowerUrl.includes('.gif')) {
      return '.gif';
    }
    if (lowerUrl.includes('.svg')) {
      return '.svg';
    }
    if (lowerUrl.includes('.jpeg') || lowerUrl.includes('.jpg')) {
      return '.jpg';
    }

    // Document formats
    if (lowerUrl.includes('.pdf')) {
      return '.pdf';
    }
    if (lowerUrl.includes('.doc')) {
      return '.doc';
    }
    if (lowerUrl.includes('.docx')) {
      return '.docx';
    }

    // Default
    return '.jpg';
  }

  private static getFilePrefix(extension: string): string {
    // Video files
    if (['.mp4', '.mov', '.webm', '.avi'].includes(extension)) {
      return 'video';
    }

    // Audio files
    if (['.mp3', '.wav', '.ogg', '.m4a'].includes(extension)) {
      return 'audio';
    }

    // Image files
    if (['.jpg', '.jpeg', '.png', '.webp', '.gif', '.svg'].includes(extension)) {
      return 'image';
    }

    // Document files
    if (['.pdf', '.doc', '.docx'].includes(extension)) {
      return 'document';
    }

    return 'file';
  }

  private static createFilename(prefix: string, extension: string): string {
    const randomString = Math.random().toString(36).substring(2, 10);
    const timestamp = Date.now();

    return `${prefix}_${randomString}_${timestamp}${extension}`;
  }

  static generateSimpleFilename(extension: string): string {
    const prefix = this.getFilePrefix(extension);
    return this.createFilename(prefix, extension);
  }
}
